import "./main.css"

import Components from "@ui-kit/components"

import { runApp } from "@versatile-credit-apply/sdk"

import { i18n } from "./i18n"
import { routerSettings } from "./router"
import { defineAsyncComponent } from "vue"

runApp({
  api: {
    omniApply: {
      baseUrl: import.meta.env.VITE_APP_APPLY_API_URL,
    },
  },
  i18n: i18n,
  mode: import.meta.env.MODE === "production" ? "production" : "development",
  plugins: [Components],
  root: defineAsyncComponent(() => import("./RetailApp.vue")),
  router: routerSettings,
})
